import React from 'react';
import {
  RadioButton,
  RadioButtonChangeEvent
} from '@progress/kendo-react-inputs';

import { GetResourceValue } from '../../../../utils/game-document';
import { GameDocumentContext } from '../../../../contexts/game-document';
import { TaskContentAnswer } from '../../../../types/game-document/entities/task-content';

const AnswerRadio: React.FC<{ answers: TaskContentAnswer[] }> = ({
  answers
}) => {
  const [state] = React.useContext(GameDocumentContext);
  const [selectedValue, setSelectedValue] = React.useState('');

  const handleChange = React.useCallback(
    (e: RadioButtonChangeEvent) => {
      setSelectedValue(e.value);
    },
    [setSelectedValue]
  );

  const options = answers.map(
    (answer) => GetResourceValue(state.gameDocument!, answer.answerResId) ?? ''
  );

  return (
    <div id={'answer-radio'}>
      {options.map((option, idx) => (
        <div
          className={`d-flex flex-row justify-content-center align-items-center card border border-2 w-100 my-2 border-dark`}
          key={option}>
          <div className={'card-body flex-grow-1'}>
            <RadioButton
              id={`radio-option-${idx}`}
              className={`border border-2 border-dark`}
              size={'large'}
              label={option}
              value={option}
              checked={selectedValue === option}
              onChange={handleChange}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default AnswerRadio;
